import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "position", "maxWidth", "minWidth", "maxHeight", "minHeight", "htmlTag", "direction", "spacing", "align", "justify", "wrap", "css", "style"];
import React from "react";
import { BaseFlex } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Flex(_ref) {
  var width = _ref.width,
    height = _ref.height,
    position = _ref.position,
    maxWidth = _ref.maxWidth,
    minWidth = _ref.minWidth,
    maxHeight = _ref.maxHeight,
    minHeight = _ref.minHeight,
    htmlTag = _ref.htmlTag,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "column" : _ref$direction,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? "md" : _ref$spacing,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? "stretch" : _ref$align,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? "start" : _ref$justify,
    _ref$wrap = _ref.wrap,
    wrap = _ref$wrap === void 0 ? "noWrap" : _ref$wrap,
    css = _ref.css,
    style = _ref.style,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseFlex, _extends({
    spacing: spacing,
    align: align,
    justify: justify,
    wrap: wrap,
    as: htmlTag,
    css: {
      width: width,
      height: height,
      position: position,
      maxWidth: maxWidth,
      minWidth: minWidth,
      maxHeight: maxHeight,
      minHeight: minHeight,
      flexDirection: direction
    }
  }, restProps));
}
export default Flex;